import { SaveCustomerEntityDto } from '@/dto/saveCustomer.dto';
import axios, { AxiosInstance, AxiosResponse } from 'axios';
import axiosRetry from 'axios-retry';

export default class PartnerConfigHttp {
    public readonly instance: AxiosInstance;
    constructor () {
    	this.instance = axios.create({
    		baseURL: process.env.VUE_APP_PARTNER_CONFIG_HTTP_BASE_URL,
    		responseType: 'json'
    	});
    	axiosRetry(this.instance, {});
    }

    async sendPartnerConfig (customer: SaveCustomerEntityDto) {
    	return new Promise<void>((resolve, reject) => {
    		this.instance.post('/order-forms/v2', customer)
    			.then((response) => {
    				resolve();
    			})
    			.catch((err) => {
    				reject(err);
    			})
    	})
    }

    async sendTokenConfig (token: string) {
    	return new Promise<void>((resolve, reject) => {
    		this.instance.post('/order-forms/confirm', { token })
    			.then((response) => {
    				resolve();
    			})
    			.catch((err) => {
    				reject(err);
    			})
    	})
    }

    async confirmToolUserAccount (token: string) {
    	return new Promise<void>((resolve, reject) => {
    		this.instance.post('partner/confirm-branded-tooluser/' + token)
    			.then((response) => {
    				resolve();
    			})
    			.catch((err) => {
    				reject(err);
    			});
    	});
    }
}
